var _circle, _circle2, _circle3, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReport2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 101,
    viewBox: "0 0 101 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50.5,
    cy: 50.5,
    r: 50.5,
    fill: "#B28A4C",
    fillOpacity: 0.2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 51,
    cy: 50,
    r: 40,
    fill: "#B28A4C",
    fillOpacity: 0.2
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 51,
    cy: 50,
    r: 28,
    fill: "#B28A4C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63.5834 56.544C63.5828 58.1965 63.018 59.7992 61.9823 61.0869C60.9467 62.3746 59.5024 63.27 57.8885 63.6249L57.1176 61.3121C57.8235 61.1959 58.4949 60.9244 59.0833 60.5174C59.6717 60.1104 60.1624 59.5779 60.5202 58.9583H57.5417C56.9007 58.9583 56.2861 58.7037 55.8328 58.2505C55.3796 57.7973 55.125 57.1826 55.125 56.5416V51.7083C55.125 51.0674 55.3796 50.4527 55.8328 49.9995C56.2861 49.5462 56.9007 49.2916 57.5417 49.2916H61.0918C60.7969 46.9558 59.6598 44.8078 57.8938 43.2508C56.1279 41.6937 53.8544 40.8346 51.5 40.8346C49.1456 40.8346 46.8722 41.6937 45.1062 43.2508C43.3402 44.8078 42.2031 46.9558 41.9083 49.2916H45.4584C46.0993 49.2916 46.714 49.5462 47.1672 49.9995C47.6204 50.4527 47.875 51.0674 47.875 51.7083V56.5416C47.875 57.1826 47.6204 57.7973 47.1672 58.2505C46.714 58.7037 46.0993 58.9583 45.4584 58.9583H41.8334C41.1924 58.9583 40.5777 58.7037 40.1245 58.2505C39.6713 57.7973 39.4167 57.1826 39.4167 56.5416V50.5C39.4167 43.8263 44.8264 38.4166 51.5 38.4166C58.1736 38.4166 63.5834 43.8263 63.5834 50.5V56.5416V56.544Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReport2);
export default __webpack_public_path__ + "static/media/report2.7e92aba262cdf01c52ec40a82cad203d.svg";
export { ForwardRef as ReactComponent };